var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_leaveReason_form_editTitle")
        : _vm.$t("label_essweb_leaveReason_form_viewTitle"),
      widthClass: "max-1000",
      delBtn: "",
      backgroundClass: "white",
      editBtn: !_vm.iSEdited,
      initData: _vm.LeaveReasonData,
      checkData: [
        "leave_reason_name",
        "sequence",
        "leave_reason_description",
        "leave_reason_code",
        "leave_type_uuid",
        "remarks",
      ],
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_leaveReason_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            maxlength: "100",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.LeaveReasonData.leave_reason_name,
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_leaveReasonNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.LeaveReasonData.leave_reason_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveReason_form_leaveTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.leaveType,
                            "item-text": "leave_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            placeholder: _vm.$t(
                              "label_essweb_leaveReason_form_leaveTypeLabel"
                            ),
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.LeaveReasonData.leave_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.LeaveReasonData,
                                "leave_type_uuid",
                                $$v
                              )
                            },
                            expression: "LeaveReasonData.leave_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            maxlength: "10",
                            type: "number",
                            isNotRequire: "",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 10]
                            ),
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_sequenceLabel"
                            ),
                          },
                          model: {
                            value: _vm.LeaveReasonData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.LeaveReasonData, "sequence", $$v)
                            },
                            expression: "LeaveReasonData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "50",
                            readonly: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_codeLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.LeaveReasonData.leave_reason_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.LeaveReasonData,
                                "leave_reason_code",
                                $$v
                              )
                            },
                            expression: "LeaveReasonData.leave_reason_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData:
                              _vm.LeaveReasonData.leave_reason_description,
                            maxlength: "500",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.LeaveReasonData.leave_reason_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveReason_form_RemarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                          },
                          model: {
                            value: _vm.LeaveReasonData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.LeaveReasonData, "remarks", $$v)
                            },
                            expression: "LeaveReasonData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }